import React from 'react';
import { Pagination } from 'antd';

const PaginationComp = ({ pageInfo, onChange, ...children }) => {
	return (
		<div className="page_nav_ct">
			<br />
			<Pagination
				current={pageInfo?.pageIndex || 1}
				total={pageInfo?.totalCnt || 0}
				pageSize={pageInfo?.recordCountPerPage || 0}
				onChange={onChange}
				showSizeChanger={false}
				{...children}
			/>
		</div>
	)
}

export default PaginationComp;